












































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import { Size } from '@front-app/components/constants';
import { VueConstructor } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { FontAwesomeIconProps } from '@front-app/vendor/icon-definitions';
import TrButton from '@front-app/components/buttons/TrButton.vue';
import { HighlightsButtonMeta, HighlightsButtonStyle, HighlightsElementPalette } from '../../../model';

export default defineComponent({
	components: {
		TrButton,
		FontAwesomeIcon,
	},
	props: {
		tag: {
			type: [String, Object] as PropType<null | string | VueConstructor>,
			default: null,
		},
		dontCaptureMousedown: {
			type: Boolean,
		},
		meta: {
			type: Object as PropType<HighlightsButtonMeta>,
			required: true,
		},
		icon: {
			type: [Object, Boolean] as PropType<FontAwesomeIconProps | false>,
			default: false,
		},
		id: {
			type: String,
			default: '',
		},
		inactive: Boolean,
		isLoading: Boolean,
		disabled: Boolean,
	},
	setup(props, ctx) {
		const is = computed(() => (props.tag ? props.tag : TrButton));
		const onMousedown = (e: MouseEvent) => {
			if (props.dontCaptureMousedown) {
				return;
			}
			e.preventDefault();
			ctx.emit('mousedown', e);
		};
		const onClick = (e: MouseEvent) => {
			if (props.inactive) {
				e.preventDefault();
			} else {
				ctx.emit('click', e);
			}
		};
		const computedSize = computed(() => (props.meta.size ? props.meta.size : Size.LARGE));
		return {
			is,
			onClick,
			onMousedown,
			computedSize,
			Size,
			HighlightsButtonStyle,
			HighlightsElementPalette,
		};
	},
});
